<template>
  <div
    class="dashboard-header-container"
    :style="headerContainerStyle"
  >
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      marginBehindNavBar: state => state.main.marginBehindNavBar,
    }),
    headerContainerStyle() {
      return `width: calc(100vw - ${this.marginBehindNavBar}px);
              margin-left: calc(-1 * ((100vw - 100% - ${this.marginBehindNavBar}px) / 2));`;
    },
  },
};
</script>

<style scoped>
.dashboard-header-container-old {
  width: 100vw;
  margin-left: calc(-1 * ((100vw - 100%) / 2));
  height: 68px;
  border-top: 1px solid #C1CCD4;
  border-bottom: 1px solid #C1CCD4;
  background-color: #FFFFFF;
}

.dashboard-header-container {
  height: 68px;
  border-top: 1px solid #C1CCD4;
  border-bottom: 1px solid #C1CCD4;
  background-color: #FFFFFF;
}
</style>
